var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14C18.2239 14 18 14.2239 18 14.5C18 14.7761 18.2239 15 18.5 15H19.5C19.7761 15 20 14.7761 20 14.5C20 14.2239 19.7761 14 19.5 14H18.5Z",
    fill: "#EFF2F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.5C18 18.2239 17.7761 18 17.5 18H14.5C14.2239 18 14 18.2239 14 18.5C14 18.7761 14.2239 19 14.5 19H17.5C17.7761 19 18 18.7761 18 18.5Z",
    fill: "#EFF2F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.5C14 20.2239 14.2239 20 14.5 20H17.5C17.7761 20 18 20.2239 18 20.5C18 20.7761 17.7761 21 17.5 21H14.5C14.2239 21 14 20.7761 14 20.5Z",
    fill: "#EFF2F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5655 9.49485C17.201 9.17584 16.733 9 16.2485 9H14C12.8954 9 12 9.89543 12 11V12H11C9.89543 12 9 12.8954 9 14V18C9 19.1046 9.89543 20 11 20H12V21C12 22.1046 12.8954 23 14 23H18C19.1046 23 20 22.1046 20 21V20H21C22.1046 20 23 19.1046 23 18V14C23 12.8954 22.1046 12 21 12H19.9581C19.8702 11.5777 19.6471 11.1912 19.317 10.9024L17.5655 9.49485ZM12 16V19H11C10.4477 19 10 18.5523 10 18V14C10 13.4477 10.4477 13 11 13H13.2538C13.406 13.0039 13.5674 13.0027 13.7354 13.0014C13.822 13.0007 13.9103 13 14 13H18C18.0897 13 18.1779 13.0007 18.2645 13.0014C18.4325 13.0027 18.594 13.0039 18.7462 13H21C21.5523 13 22 13.4477 22 14V18C22 18.5523 21.5523 19 21 19H20V16H12ZM18.9132 12C18.8549 11.8694 18.7686 11.7513 18.6585 11.655L16.907 10.2474C16.7247 10.0879 16.4908 10 16.2485 10H14C13.4477 10 13 10.4477 13 11V12H18.9132ZM19 17H13V21C13 21.5523 13.4477 22 14 22H18C18.5523 22 19 21.5523 19 21V17Z",
    fill: "#EFF2F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.e157bfcff76dc8dded30f7a06d3699fe.svg";
export { ForwardRef as ReactComponent };